/**
 * AI Content Type Service
 * Service for fetching AI content types for generation
 */

import { sharedApiClient } from './client';
import type {
  AIContentType,
  AIContentTypeListResponse,
  AIContentTypeListParams,
} from './aiContentType.types';

/**
 * AI Content Type Service Class
 * Handles fetching AI content types for content generation
 */
class AIContentTypeService {
  private basePath = '/content';

  /**
   * List all active AI content types
   * GET /content/ai-types/
   */
  async listAIContentTypes(params?: AIContentTypeListParams): Promise<AIContentTypeListResponse> {
    const queryParams = new URLSearchParams();
    
    if (params?.category) {
      queryParams.append('category', params.category);
    }
    if (params?.search) {
      queryParams.append('search', params.search);
    }

    const queryString = queryParams.toString();
    const url = queryString
      ? `${this.basePath}/ai-types/?${queryString}`
      : `${this.basePath}/ai-types/`;

    const response = await sharedApiClient.get<AIContentTypeListResponse>(url);
    return response.data;
  }

  /**
   * Get AI content type by slug
   * Convenience method that filters from the list
   */
  async getBySlug(slug: string): Promise<AIContentType | null> {
    const response = await this.listAIContentTypes();
    return response.results.find((item) => item.slug === slug) || null;
  }
}

export const aiContentTypeService = new AIContentTypeService();

export default aiContentTypeService;
